/** Public storefront URL for the shop (https://{shop}.myshopify.com/). */
export function getStorefrontUrl(shop) {
  const d = normalizeShopDomain(shop);
  if (!d) return "";
  try {
    return new URL(`https://${d}`).href;
  } catch {
    return "";
  }
}

/** Normalize shop to *.myshopify.com for hooks that need a domain. */
export function normalizeShopDomain(input) {
  if (input == null || typeof input !== "string") return "";
  const s = input.trim();
  if (!s) return "";
  return s.includes(".myshopify.com") ? s : `${s}.myshopify.com`;
}

/** Read shop from the embedded app URL when Redux has not set it yet. */
export function getShopFromWindow() {
  if (typeof window === "undefined") return "";
  const raw = new URLSearchParams(window.location.search).get("shop");
  return normalizeShopDomain(raw);
}

/**
 * Shopify Admin checkout editor (store context comes from the embedded admin session).
 * Path only `/settings/checkout/editor` on admin host — no `/store/{handle}/` segment.
 */
export function getShopifyAdminCheckoutEditorUrl() {
  try {
    return new URL("/settings/checkout/editor", "https://admin.shopify.com").href;
  } catch {
    return "https://admin.shopify.com/settings/checkout/editor";
  }
}
